module.exports = __webpack_public_path__ + "assets/img/425e1460f5f9a947d7b9d8b1d43f02cf.png";